import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class MetricsSourcesTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.METRICS_SOURCES;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_METRICS_SOURCES;

	get id(): string {
		return TourId.METRICS_SOURCES;
	}

	override get keyForPersistantDone(): string {
		return MetricsSourcesTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				attachTo: () => {
					return $('.metric-library-source-about .source-type__select').eq(0);
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}
}
